export var fontTokens = {
  family: {
    heading: "'Open Sans', Arial, Helvetica, sans-serif",
    body: "'Open Sans', Arial, Helvetica, sans-serif",
    caption: "'Open Sans', Arial, Helvetica, sans-serif",
    link: "'Open Sans', Arial, Helvetica, sans-serif",
    label: "'Open Sans', Arial, Helvetica, sans-serif"
  },
  weight: {
    regular: 400,
    semiBold: 500,
    bold: 700
  },
  size: {
    '2xs': '0.75rem',
    // 12px
    xs: '0.875rem',
    // 14px
    sm: '1rem',
    // 16px
    md: '1.125rem',
    // 18px
    lg: '1.25rem',
    // 20px
    xl: '1.5rem',
    // 24px
    '2xl': '2rem',
    // 32px
    '3xl': '2.5rem' // 40px
  },
  lineHeight: {
    '2xs': '16px',
    xs: '20px',
    sm: '24px',
    md: '28px',
    lg: '32px',
    xl: '40px',
    '2xl': '48px'
  }
};